module.exports = __webpack_public_path__ + "img/chadle2_1.3c2c6ead.png";